import React, { useState, useEffect } from 'react';
import { getErrorMessage } from '@utils/commons';
import { useErrors } from '@contexts/ErrorsContext';
import { AcmpType } from '../../../utils';

interface AcmpUpdatedDateProps {
  acmp: AcmpType;
  setAcmp: React.Dispatch<React.SetStateAction<AcmpType>>;
}

const AcmpUpdatedDate: React.FC<AcmpUpdatedDateProps> = ({ acmp, setAcmp }) => {
  const [acmpUpdatedDateErrMessage, setAcmpUpdatedDateErrMessage] = useState<
    string | undefined
  >('');
  const { errors } = useErrors();

  useEffect(() => {
    setAcmpUpdatedDateErrMessage(getErrorMessage(errors, 'acmpUpdatedDate'));
  }, [errors]);

  const handleDateChange = (field: 'day' | 'month' | 'year', value: string) => {
    setAcmp(prev => ({
      ...prev,
      updatedDate: { ...prev.updatedDate, [field]: value },
    }));
  };

  return (
    <div>
      <div
        className={`govuk-form-group ${acmpUpdatedDateErrMessage ? 'govuk-form-group--error' : ''}`}
      >
        <fieldset
          className="govuk-fieldset"
          role="group"
          aria-describedby="plan-updated-date-hint"
        >
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Date the ACMP was last updated
            </h1>
          </legend>
          <div id="plan-updated-date-hint" className="govuk-hint">
            For example, 31 3 2026
          </div>
          {acmpUpdatedDateErrMessage && (
            <p id="full-name-input-error" className="govuk-error-message">
              <span className="govuk-visually-hidden">Error:</span>
              {acmpUpdatedDateErrMessage}
            </p>
          )}
          <div className="govuk-date-input__item">
            <div className="govuk-form-group">
              <label
                className="govuk-label govuk-date-input__label"
                htmlFor="acmpUpdatedDate"
              >
                Day
              </label>

              <input
                className={`govuk-input govuk-date-input__input govuk-input--width-2 ${acmpUpdatedDateErrMessage ? 'govuk-input--error' : ''}`}
                id="acmpUpdatedDate"
                name="acmpUpdatedDate"
                type="text"
                inputMode="numeric"
                maxLength={2}
                placeholder="DD"
                value={acmp.updatedDate.day}
                onChange={e => {
                  const { value } = e.target;
                  if (/^[0-9]*$/.test(value) && value.length <= 2) {
                    handleDateChange('day', value);
                  }
                }}
              />
            </div>
          </div>
          <div className="govuk-date-input__item">
            <div className="govuk-form-group">
              <label
                className="govuk-label govuk-date-input__label"
                htmlFor="acmp-updated-date-month"
              >
                Month
              </label>
              <input
                className={`govuk-input govuk-date-input__input govuk-input--width-2 ${acmpUpdatedDateErrMessage ? 'govuk-input--error' : ''}`}
                id="acmp-updated-date-month"
                name="acmp-updated-date-month"
                type="text"
                inputMode="numeric"
                placeholder="MM"
                maxLength={2}
                value={acmp.updatedDate.month}
                onChange={e => {
                  const { value } = e.target;
                  if (/^[0-9]*$/.test(value) && value.length <= 2) {
                    handleDateChange('month', value);
                  }
                }}
              />
            </div>
          </div>
          <div className="govuk-date-input__item">
            <div className="govuk-form-group">
              <label
                className="govuk-label govuk-date-input__label"
                htmlFor="acmp-updated-date-year"
              >
                Year
              </label>
              <input
                className={`govuk-input govuk-date-input__input govuk-input--width-4 ${acmpUpdatedDateErrMessage ? 'govuk-input--error' : ''}`}
                id="acmp-updated-date-year"
                name="acmp-updated-date-year"
                type="text"
                inputMode="numeric"
                placeholder="YYYY"
                maxLength={4}
                value={acmp.updatedDate.year}
                onChange={e => {
                  const { value } = e.target;
                  if (/^[0-9]*$/.test(value) && value.length <= 4) {
                    handleDateChange('year', value);
                  }
                }}
              />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default AcmpUpdatedDate;
